import React from "react";
import PropTypes from "prop-types";
import { PrimaryButton, ButtonLink } from "../../../../components/Buttons";
import {
  W3Dropdown,
  W3DropdownToggler,
  W3DropdownContent,
} from "../../../../components/W3Dropdown";
import ITTaskDialog from "./ITTaskDialog";
import ActionFilter from "../ActionFilter";

export default function ADWorkplaceTaskMenu({
  className = "",
  items = [],
  selectedADWorkplaceTasks,
  filterConnections,
  connectionTaskType,
  exportADWorkplaceTasks,
  closeADWorkplaceTasks,
}) {
  const taskDialogRef = React.useRef(null);

  const onExport = React.useCallback(
    (event) => {
      if (event) event.preventDefault();
      const type = "VBG";
      let counter = 0;
      if (selectedADWorkplaceTasks && selectedADWorkplaceTasks.length > 0) {
        counter += selectedADWorkplaceTasks.length;
      }
      taskDialogRef.current.show(
        true,
        {
          title: `VBG - CSC Kennungen exportieren`,
          text: `
          Alle ${counter} ausgewählte VBG - CSC Kennungen werden für die Weiterverarbeitung vorbereitet und als CSV exportiert.  
          Wollen Sie fortfahren?
        `,
          type: type.toUpperCase(),
          showValidity: false,
          taskType: connectionTaskType,
          showTaskType: false,
        },
        (data) => exportADWorkplaceTasks(data),
      );
    },
    [selectedADWorkplaceTasks, connectionTaskType, exportADWorkplaceTasks],
  );

  const onClose = React.useCallback(
    (event) => {
      if (event) event.preventDefault();
      const type = "VBG";
      let counter = 0;
      if (selectedADWorkplaceTasks && selectedADWorkplaceTasks.length > 0) {
        counter += selectedADWorkplaceTasks.length;
      }
      taskDialogRef.current.show(
        true,
        {
          title: `VBG – CSC Kennungen schließen`,
          text: `
          ${counter > 1 ? "Alle" : "Die"} ausgewählte Aufgabe${counter > 1 ? "n werden" : " wird"} endgültig geschlossen.  
          Wollen Sie fortfahren?
        `,
          type: type.toUpperCase(),
          showValidity: false,
          taskType: connectionTaskType,
          showTaskType: false,
        },
        (data) => closeADWorkplaceTasks(data),
      );
    },
    [selectedADWorkplaceTasks, connectionTaskType, closeADWorkplaceTasks],
  );

  const isExportable =
    selectedADWorkplaceTasks && selectedADWorkplaceTasks.length > 0;

  return (
    <div className={className}>
      <div className="w3-cell-row">
        <div className="w3-cell w3-cell-middle pad-rht">
          <ActionFilter
            type="VBG"
            taskType={connectionTaskType}
            setTaskType={filterConnections}
            itemsToCount={items}
            className="display-inline-block"
          />
        </div>
        <div className="w3-cell w3-cell-middle pad-lft">
          <W3Dropdown className="modems dropdown-list-menu">
            <W3DropdownToggler as={PrimaryButton} size="">
              {`Optionen`}
            </W3DropdownToggler>
            <W3DropdownContent
              className="w3-bar-block w3-border"
              style={{ right: "0", width: "320px" }}
            >
              <ButtonLink
                to="#"
                className="w3-bar-item dropdown-list-menu-item bg-secondary-hover"
                onClick={onExport}
                disabled={!isExportable}
              >
                {`Exportieren (CSV)`}
              </ButtonLink>
              <a href="#" className="w3-bar-item separator">
                <div className="w3-border-top" style={{ margin: "0 -4px" }} />
              </a>
              <ButtonLink
                to={`#`}
                className="w3-bar-item dropdown-list-menu-item bg-secondary-hover"
                onClick={onClose}
                disabled={!isExportable}
              >
                {`Aufgaben schließen`}
              </ButtonLink>
            </W3DropdownContent>
          </W3Dropdown>
        </div>
      </div>
      <ITTaskDialog ref={taskDialogRef} />
    </div>
  );
}

ADWorkplaceTaskMenu.propTypes = {
  className: PropTypes.string,
  selectedADWorkplaceTasks: PropTypes.array,
  connectionTaskType: PropTypes.string,
  exportADWorkplaceTasks: PropTypes.func.isRequired,
  closeADWorkplaceTasks: PropTypes.func.isRequired,
  filterConnections: PropTypes.func.isRequired,
  items: PropTypes.array,
  history: PropTypes.object,
};
